import type { CountryCode } from "./country-config";

const apiCountryNameByCountry: Record<CountryCode, string> = {
	SE: "Sweden",
	FI: "Finland",
	NO: "Norway",
};

export const getApiCountryName = (country: CountryCode): string =>
	apiCountryNameByCountry[country];
